// src/config.ts
const env = import.meta.env.MODE;

type AppConfig = {
  apiBaseUrl: string;
  basePath: string; // For react-router-dom (if needed)
  env: string;
};

const config: Record<string, AppConfig> = {
  development: {
    apiBaseUrl: 'http://localhost:5000',
    basePath: '/api',
    env: 'development'
  },
  production: {
    apiBaseUrl: 'https://pipelyze.com',
    basePath: '/api',
    env: 'production'
  },
};

export default config[env] || config.development;
